@if (tableData.layoutDefined() && !tableData.confirmed()) {
  <ct-extraction-table-overlay-row-remove-container
    [isIgnored]="isIgnored"
    (buttonClicked)="toggleIgnoreForRow.emit()" />
}
